/// <reference lib="webworker" />
import { rpcTransportMessageIn, rpcTransportMessageOut, } from "../transport-utils.js";
/**
 * Creates a transport from objects that support `postMessage(message)`
 * and `addEventListener("message", listener)`. This includes `Window`,
 * `Worker`, `MessagePort`, and `BroadcastChannel`.
 *
 * This is useful for RPCs between, among other things, iframes or workers.
 */
export function createTransportFromMessagePort(
/**
 * The local port that will receive and handled "message" events
 * through `addEventListener("message", listener)`. If the `remotePort`
 * option is omitted, it will also be used to send messages through
 * `postMessage(message)`.
 */
port, 
/**
 * Options for the message port transport.
 */
options = {}) {
    const { transportId, filter, remotePort } = options;
    // little white TypeScript lies
    const local = port;
    const remote = (remotePort ?? port);
    let transportHandler;
    return {
        send(data) {
            remote.postMessage(rpcTransportMessageOut(data, { transportId }));
        },
        registerHandler(handler) {
            transportHandler = (event) => {
                const message = event.data;
                const [ignore, data] = rpcTransportMessageIn(message, {
                    transportId,
                    filter: () => filter?.(event),
                });
                if (ignore)
                    return;
                handler(data);
            };
            local.addEventListener("message", transportHandler);
        },
        unregisterHandler() {
            if (transportHandler)
                local.removeEventListener("message", transportHandler);
        },
    };
}
// TODO: message port transport tests.
